module.exports = __webpack_public_path__ + "static/media/arrow-black.2fe3c0a2.svg";